import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
// --- 1. Import Redux hooks and actions ---
import { useDispatch } from 'react-redux';
import { loginSuccess } from '../../authSlice';

const ClientEmailVerify = () => {
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get('token');
  const hasAttemptedVerification = useRef(false);
  
  // --- 2. Initialize the dispatch function ---
  const dispatch = useDispatch();

  useEffect(() => {
    const clientEmailVerify = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/verify-email?token=${token}`,
          { withCredentials: true }
        );

        // --- 3. Get the data from the API response ---
        // This assumes the backend is sending { userName, userId, verified, event, ... }
        const loginData = response.data.data;

        // --- 4. Manually build the user object for Redux ---
        const userWithRole = {
          _id: loginData.userId,
          name: loginData.userName,
          verified: loginData.verified, // This will be true
          role: 'Client'
        };
        
        // --- 5. THIS IS THE FIX: Dispatch loginSuccess ---
        // This saves the user to Redux AND localStorage
        dispatch(loginSuccess(userWithRole));

        alert('Email verified successfully! You are now logged in.');

        // 6. Navigate to the correct page
        if (loginData.event) {
          navigate("/booth2", { state: { event: loginData.event } });
        } else {
          navigate('/client-home');
        }

      } catch (error) {
        console.error('Verification failed:', error);
        navigate('/check-verification');
      }
    };

    if (token) {
      if (hasAttemptedVerification.current === false) {
        hasAttemptedVerification.current = true;
        clientEmailVerify();
      }
    } else {
      navigate('/check-verification');
    }
  // --- 7. Add dispatch to the dependency array ---
  }, [token, navigate, dispatch]);

  return <div>Verifying your email and logging you in...</div>;
};

export default ClientEmailVerify;